<template>
    <!-- 专家工作室 -->
    <div class="studio-entrance">
        <div class="banner">
            <div class="banner-inner">
                <h2 class="title">专家工作室</h2>
                <ul class="menu-list">
                    <!-- <li v-for="(item,index) in menuList" :key="index" class="menu-item flex-layout"
                        :class="{'active-menu':activeMenu == index}" @click="chooseMenu(index)">
                        <div class="type-warp">
                            <img :src="item.icon" alt="" class="menu-img">
                            <span>{{item.name}}</span>
                            <img src="../../assets/studio/icon-4.png" alt="" class="menu-arrow">
                        </div>
                        <div class="menu-child-list">
                            <span v-for="(each,i) in  menuList[index].child" :key="i" class="child-item csp"
                                :class="{'active-menu':activeChildMenu == i}"
                                @click="activeChildMenu = i">{{each.name}}</span>
                        </div>
                    </li> -->
                    <li class="menu-item flex-layout">
                        <div class="type-warp">
                            <img :src="menuList[0].icon" alt="" class="menu-img">
                            <span>{{menuList[0].name}}</span>
                            <img src="../../assets/studio/icon-4.png" alt="" class="menu-arrow">
                        </div>
                        <div class="menu-child-list">
                            <span v-for="(each,i) in  menuList[0].child" :key="i" class="child-item csp"
                                :class="{'active-menu':activeType == i}" @click="activeType = i">{{each.name}}</span>
                        </div>
                    </li>
                    <li class="menu-item flex-layout">
                        <div class="type-warp">
                            <img :src="menuList[1].icon" alt="" class="menu-img">
                            <span>{{menuList[1].name}}</span>
                            <img src="../../assets/studio/icon-4.png" alt="" class="menu-arrow">
                        </div>
                        <div class="menu-child-list">
                            <span v-for="(each,i) in  menuList[1].child" :key="i" class="child-item csp"
                                :class="{'active-menu':activeSubject == i}"
                                @click="activeSubject = i">{{each.name}}</span>
                        </div>
                    </li>
                    <li class="menu-item flex-layout">
                        <div class="type-warp">
                            <img :src="menuList[2].icon" alt="" class="menu-img">
                            <span>{{menuList[2].name}}</span>
                            <img src="../../assets/studio/icon-4.png" alt="" class="menu-arrow">
                        </div>
                        <div class="menu-child-list">
                            <span v-for="(each,i) in  menuList[2].child" :key="i" class="child-item csp"
                                :class="{'active-menu':activeManage == i}"
                                @click="activeManage = i">{{each.name}}</span>
                        </div>
                    </li>

                </ul>
            </div>
        </div>
        <div class="studio-inner">
            <ul class="studio-list flex-layout">
                <li class="studio-item csp" v-for="(item,index) in 5" :key="index" @click="goStudio(index)">
                    <div class="img-warp">
                        <img src="../../assets/studio/image-1.png" alt="" class="studio-img">
                    </div>
                    <span class="studio-title">XXXxxXX工作室</span>
                    <div class="studio-info">
                        <p class="teacher-name">主持人：王海燕</p>
                        <p class="studio-desc wes-3">主要从事教育基本原理、课程与教学论、教师教育、历史教学等方面的教学与研究。中国教育学会农村教育分会副秘书长。</p>
                    </div>
                    <div class="studio-bar flex-align-between">
                        <span class="studio-sort">查看</span>
                        <span class="studio-go"></span>
                    </div>

                </li>
            </ul>
            <!-- <pagination v-show="pages.total > 0" :total="pages.total" :page.sync="pages.currentPage" :small="true"
                :limit.sync="pages.pageSize" :pageSizes="[8,16,24]" :layout="'prev,pager,next'"
                @pagination="handlePageChange">
            </pagination> -->
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                activeMenu: 0,
                // activeChildMenu: 0,
                activeType: 0,
                activeSubject: 0,
                activeManage: 0,
                menuList: [{
                        name: '分类',
                        icon: require("../../assets/studio/icon-1.png"),
                        child: [{
                                name: '全部'
                            },
                            {
                                name: '学科'
                            },
                            {
                                name: '管理'
                            }
                        ],
                    },
                    {
                        name: '学科',
                        icon: require("../../assets/studio/icon-2.png"),
                        child: [{
                                name: '全部'
                            },
                            {
                                name: '语文'
                            },
                            {
                                name: '数学'
                            },
                            {
                                name: '英语'
                            },
                            {
                                name: '物理'
                            },
                            {
                                name: '化学'
                            },
                            {
                                name: '生物'
                            },
                            {
                                name: '政治'
                            },
                            {
                                name: '历史'
                            },
                            {
                                name: '地理'
                            },
                        ],
                    },
                    {
                        name: '管理',
                        icon: require("../../assets/studio/icon-3.png"),
                        child: [{
                                name: '全部'
                            },
                            {
                                name: '学校发展'
                            },
                            {
                                name: '学校评价'
                            }
                        ],
                    },
                ],
                // pages: { //分页
                //     currentPage: 1,
                //     pageSize: 8,
                //     total: 100,
                // },
            }
        },
        methods: {
            chooseMenu(index) {
                this.activeMenu = index;
            },
            goStudio(index) {
                this.$router.push(`/home/studio/${index}`)
            }
        }
    }
</script>

<style lang="less" scoped>
    .studio-entrance {
        .banner {
            background-image: url("../../assets/studio/banner.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            height: 56vh;
            max-height: 530px;
            min-height: 360px;
            position: relative;

            .banner-inner {
                position: absolute;
                width: 100%;
                top: 22%;
                left: 5.1%;
            }

            .title {
                width: 21%;
                font-size: 48px;
                color: #fff;
                margin-bottom: 2%;
                letter-spacing: 2px;
                text-align: center;
            }

            .type-warp {
                width: 21%;
                color: #fff;
                font-size: 30px;
                line-height: 2.7;
                letter-spacing: 26px;
                text-align: center;
                border-bottom: 1px solid #6b8dbb;

                &:first-child {
                    border-top: 1px solid #6b8dbb;
                }

                .menu-img {
                    margin-right: 8.7%;
                    display: inline-block;
                    vertical-align: text-bottom;
                }

                .menu-arrow {
                    margin-left: 10%;
                    display: inline-block;
                    vertical-align: middle;
                }
            }

            .menu-child-list {
                width: 60%;
                font-size: 24px;
                border-bottom: 2px solid transparent;
                background-color: rgba(255, 255, 255, .8);
                background-clip: content-box;
                line-height: 3.41;

                .active-menu {
                    color: #007EE9;
                }

                .child-item {
                    display: inline-block;
                    padding: 0 2.4%;

                    &:first-child {
                        padding-left: 5%;
                    }
                }
            }
        }


        .studio-inner {
            padding: 5.7% 5.2% 50%;


            .studio-list {
                flex-wrap: wrap;
            }


            .studio-item {
                margin-right: 4.4%;
                margin-bottom: 4.2%;
                border: 1px solid #d2d2d2;
                border-radius: 5px;
                width: calc((100% - 4.8% * 2) / 3);
                transition: 1s all;
                position: relative;


                &:nth-child(3n) {
                    margin-right: 0;
                }

                &:hover {
                    box-shadow: 0px 6px 35px 2px rgba(30, 19, 15, 0.11);

                    .studio-bar {
                        color: #F89321;

                        .studio-go {
                            background-image: url("../../assets/studio/icon-6.png");
                        }
                    }
                }
            }

            .img-warp {
                width: 100%;
                height: 404px;
                overflow: hidden;
            }

            .studio-img {
                width: 100%;
            }

            .studio-title {
                display: inline-block;
                border-radius: 0 12px 12px 0;
                padding: 0 10% 0 8%;
                color: #fff;
                font-size: 30px;
                line-height: 2.13;
                background-color: #00A0E9;
                position: absolute;
                left: 0;
                top: 361px;
            }

            .studio-info {
                padding: 10.5% 10.5% 7.3% 7.3%;
            }

            .teacher-name {
                font-size: 30px;
                margin-bottom: 8%;
            }

            .studio-desc {
                font-size: 20px;
                font-weight: 300;
                line-height: 1.8;
            }

            .studio-bar {
                font-size: 16px;
                color: #666;
                font-weight: 300;
                padding: 5.3% 0 5.6%;
                border-top: 1px solid rgba(181, 181, 181, .4);
                margin: 0 7.3%;

                &:hover {
                    color: #F89321;

                    .studio-go {
                        background-image: url("../../assets/studio/icon-6.png");
                    }
                }
            }

            .studio-go {
                width: 23px;
                height: 8px;
                background-image: url("../../assets/studio/icon-5.png");
                background-repeat: no-repeat;
                background-size: 100% 100%;
            }
        }



        @media screen and (max-width:1850px) {
            .banner {

                .title {
                    font-size: 40px;
                }

                .type-warp {
                    font-size: 25px;
                    letter-spacing: 20px;

                }

                .menu-child-list {
                    font-size: 20px;
                }
            }

            .studio-inner {

                .img-warp {
                    height: 337px;
                }


                .studio-title {
                    font-size: 25px;
                    top: 301px;
                }

                .teacher-name {
                    font-size: 25px;
                }

                .studio-desc {
                    font-size: 17px;
                }

                .studio-bar {
                    font-size: 13px;
                }
            }
        }

        @media screen and (max-width:1450px) {
            .banner {

                .title {
                    font-size: 31px;
                }


                .type-warp {
                    font-size: 20px;
                    letter-spacing: 15px;

                    .menu-img {
                        width: 24px;
                    }

                    .menu-arrow {
                        width: 9px;
                    }
                }

                .menu-child-list {
                    font-size: 16px;
                }
            }

            .studio-inner {

                .img-warp {
                    height: 263px;
                }


                .studio-title {
                    font-size: 20px;
                    top: 235px;
                }

                .teacher-name {
                    font-size: 20px;
                }

                .studio-desc {
                    font-size: 14px;
                }

                .studio-bar {
                    font-size: 12px;
                }

                .studio-go {
                    width: 15px;
                    height: 5px;
                }
            }

        }

        @media screen and (max-width:1150px) {
            .banner {
                .type-warp {
                    font-size: 16px;
                    letter-spacing: 10px;

                    .menu-img {
                        width: 24px;
                    }

                    .menu-arrow {
                        width: 9px;
                    }
                }

                .menu-child-list {
                    font-size: 13px;
                }
            }

            .studio-inner {

                .img-warp {
                    height: 211px;
                }


                .studio-title {
                    font-size: 16px;
                    top: 188px;
                }

                .teacher-name {
                    font-size: 16px;
                }

                .studio-desc {
                    font-size: 12px;
                }
            }
        }
    }
</style>